<div>
	<div class="map-marker-sign-with-arrow">
		<div class="map-marker-sign-with-arrow__inner">
			<%= text %>
		</div>
		<div class="arrow-outer-border"></div>
		<div class="arrow-inner-border"></div>
		<div class="arrow-arrow-body"></div>
	</div>
</div>
